module.exports = __webpack_public_path__ + "img/coupon_icon.e20e68ed.png";